import { useEffect } from 'react';

/**
 * Hook to notify about step changes in a multistep form
 * @param currentStepIndex - The current step index within visible steps
 * @param visibleSteps - Steps currently visible in the form
 * @param onStepChange - Callback to notify about step changes
 */
function useStepChangeNotifier(currentStepIndex: number, visibleSteps: { id: string }[], onStepChange?: (isFirstStep: boolean, isLastStep: boolean, stepId: string) => void) {
  useEffect(() => {
    const stepId = visibleSteps[currentStepIndex]?.id;
    if (!stepId) return;
    onStepChange?.(currentStepIndex === 0, currentStepIndex === visibleSteps.length - 1, stepId);
  }, [currentStepIndex, visibleSteps, onStepChange]);
}

export { useStepChangeNotifier };
